import { render, staticRenderFns } from "./MedalList.vue?vue&type=template&id=09c1f445"
import script from "./MedalList.vue?vue&type=script&lang=js"
export * from "./MedalList.vue?vue&type=script&lang=js"
import style0 from "./MedalList.vue?vue&type=style&index=0&id=09c1f445&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports